import BaseModel from 'common/models/base/model';

export default BaseModel.extend({
  fromData(data) {
    let uri = data.hfSource;

    // TODO - remove this. Should never access a property on the global scope. (CC)
    // define hellofaxJS as a property of app (this.app.helloFaxJS.attachSessionInfoToUrl)
    if (window.hellofaxJS) {
      uri = hellofaxJS.attachSessionInfoToUrl(uri);
    }

    return {
      width: data.width || 680,
      height: data.height || 800,
      hfSource: uri,
      cdnSource: data.cdnSource || null,
    };
  },
});
